<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2023-02-07 12:45:58
 * @LastEditTime: 2023-02-07 15:19:48
 * @Description: 
-->
<template>
    <div class="text">
        <div :id="name" class="title">VERIFY BY TÜV SÜD No.{{id}}</div>
    </div>
</template>

<script >
import { reactive, toRefs, onBeforeMount, onMounted,defineProps  } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import $ from 'jquery'
import '@/utils/jquery.arctext'
export default {
    name: 'radianText',
    props:{
        name:{
            type:String,
            default:''
        }
    },
    setup(props) {
        const data = reactive({
            name:props.name,
            id:'',
        })
        const route = useRoute();
        const router = useRouter();
        onBeforeMount(() => {
            data.id = route.query.id.substring((route.query.id.length-6),route.query.id.length)
         })
        onMounted(() => {
            $(function(){
                $(`#${props.name}`).arctext({
                    radius:165,
                    dir:0,
                })
            })
        })
        
        return {
            ...toRefs(data),
        }
    }
}
</script>
<style scoped lang='less'>
.text {
    font-size: 12px;
    transform: rotateZ(-3deg) scale(0.91, 0.91);
    position: absolute;
    top: 267px;
    left: 54px;
}

.title {
    width: 220px;
    word-spacing: 0.1;
    font-size: 12px;
    color: #333333;
    font-weight: 600;
    transform: scale(0.83, 0.83);
    text-align: left;
}
</style>